var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 25.5C20.4036 25.5 26 19.9036 26 13C26 6.09644 20.4036 0.5 13.5 0.5C6.59644 0.5 1 6.09644 1 13C1 19.9036 6.59644 25.5 13.5 25.5Z",
    stroke: "black",
    fill: "white",
    strokeWidth: 0.93312
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79549 9.6618L20.2286 9.6618C20.3086 9.6618 20.4046 9.83091 20.4526 9.89205C20.5166 9.9532 20.5326 10.1051 20.5006 10.1815L18.7419 15.7716C18.6459 16.1375 18.31 16.3496 17.911 16.3496L11.0201 16.3496C10.6202 16.3496 10.2692 16.1681 10.1893 15.8022C10.1893 15.8022 8.7005 10.1433 8.43054 9.04365C8.15959 7.94303 7.88463 7.4873 6.75781 7.4873",
    stroke: "black",
    strokeWidth: 0.81907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.307 18.7058C13.307 19.3785 12.736 19.9232 12.0319 19.9232C11.3279 19.9232 10.7578 19.3785 10.7578 18.7058C10.7578 18.033 11.3279 17.4873 12.0319 17.4873C12.736 17.4873 13.307 18.033 13.307 18.7058Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4291 18.7058C17.4291 19.3785 16.8581 19.9232 16.154 19.9232C15.4499 19.9232 14.8799 19.3785 14.8799 18.7058C14.8799 18.033 15.4499 17.4873 16.154 17.4873C16.8581 17.4873 17.4291 18.033 17.4291 18.7058Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.4d80bebcf1ca57233a1cca4a24c8cce8.svg";
export { ForwardRef as ReactComponent };